<template>
    <v-container fluid class="pt-0">
        <v-row>
            <v-col cols="12" class="pa-0">
                <v-sheet class="" color="#008dd4" height="10vh"></v-sheet>
            </v-col>
            <v-col cols="12" style="position:relative; top: -60px">
                <v-row>
                    <v-col cols="12" lg="4">
                        <v-card>
                            <v-card-title>Datos de pago</v-card-title>
                            <v-card-text>
                                <p class="mb-0 text-center" v-if="!partnership.billing_information">
                                    Sin datos registrados, añada una tarjeta de débito.
                                </p>
                                <v-card outlined v-else>
                                    <v-card-text>
                                        <p class="my-2">N° Tarjeta : {{ partnership.billing_information.account }}</p>
                                        <v-divider></v-divider>
                                        <p class="my-2">Nombre(s) : {{ partnership.billing_information.names }}</p>
                                        <v-divider></v-divider>
                                        <p class="my-2">Banco : {{ partnership.billing_information.bank }}</p>
                                    </v-card-text>
                                </v-card>
                            </v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions class="px-0 py-0">
                                <v-btn v-if="!partnership.billing_information" text block @click="billing_information_dialog = true">Añadir</v-btn>
                                <v-btn v-else @click="billing_information_dialog = true" block>Modificar</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                    <v-col cols="12" lg="8">
                        <v-card>
                            <v-card-text>
                                <v-simple-table v-if="payments.length > 0">
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th>Fecha</th>
                                                <th>Cantidad</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(payment, index) in payments" :key="index">
                                                <td>{{ payment.date }}</td>
                                                <td>{{ payment.quantity }}</td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                                <p v-else class="mb-0 text-center">Sin pagos registrados</p>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <billingInformation :dialog="billing_information_dialog" :information="partnership.billing_information"></billingInformation>
     </v-container>
</template>
<script>

import billingInformation from './billing_information.vue'

export default {
    props:['payments','partnership'],
    components:{
        billingInformation,
    },
    data: () => ({
        billing_information_dialog:false,
    })
}
</script>